// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cnt-search {
  width: 95%;
  margin-bottom: 10px;
}

.lbl-search {
  font-weight: bold;
}

.icon-search {
  font-weight: bold;
  margin-left: 4px;
}

.inp-search {
  width: 100%;
  border-left: 1px inset black;
  border-top: 1px inset black;
  height: 30px;
}

.grid-search {
  font-size: 0.8em;
  max-height: 30px;
  padding-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/shared/grid-filters/grid-search/grid-search.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,4BAAA;EACA,2BAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AACF","sourcesContent":[".cnt-search {\n  width: 95%;\n  margin-bottom: 10px;\n}\n\n.lbl-search {\n  font-weight: bold;\n}\n\n.icon-search {\n  font-weight: bold;\n  margin-left: 4px;\n}\n\n.inp-search {\n  width: 100%;\n  border-left: 1px inset black;\n  border-top: 1px inset black;\n  height: 30px;\n}\n\n.grid-search {\n  font-size: .8em;\n  max-height: 30px;\n  padding-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
